module.exports = __webpack_public_path__ + "static/media/default_tutorial_1.1a3de012.jpg";